import { LockIcon, ZapIcon, SmartphoneIcon } from 'lucide-react';
const ITEMS = [{
  icon: LockIcon,
  text: 'Pago seguro'
}, {
  icon: ZapIcon,
  text: 'Acceso digital'
}, {
  icon: SmartphoneIcon,
  text: 'Celular o PC'
}];
type TrustLineProps = {
  align?: 'start' | 'center';
  /** Omit items by label when a card only needs a subset. */
  only?: string[];
};

/** Small reassurance row that sits under a CTA. */
export function TrustLine({
  align = 'start',
  only
}: TrustLineProps) {
  const items = only ? ITEMS.filter(i => only.includes(i.text)) : ITEMS;
  return <ul className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[0.7rem] text-aluminio/60 sm:text-xs ${align === 'center' ? 'justify-center' : ''}`} data-id="element-172" data-mp="chtno50eezmv">
      {items.map(item => <li key={item.text} className="flex items-center gap-1.5" data-id="element-173" data-mp="2p4c7a4ullrj">
          <item.icon className="h-3.5 w-3.5 shrink-0 text-electrico-light" aria-hidden="true" data-id="element-174" data-mp="107e5gkktfquk" />
          {item.text}
        </li>)}
    </ul>;
}